export default "__VITE_ASSET__T1b1kENW__"